import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Badge } from 'src/app/models/community';
import { CommunityService } from 'src/app/services/community.service';
import { I18nService } from 'src/app/services/i18n.service';

type BadgeFilter = 'all' | 'unlocked' | 'inProgress';

@Component({
  selector: 'app-user-badges',
  templateUrl: './user-badges.component.html',
  styleUrls: ['./user-badges.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class UserBadgesComponent implements OnInit {

  badges: Badge[] = [];
  filter: BadgeFilter = 'all';
  loading = true;
  error = '';

  constructor(private communityService: CommunityService, public i18n: I18nService) { }

  ngOnInit(): void {
    this.load();
  }

  load(): void {
    this.loading = true;
    this.error = '';
    this.communityService.badges().subscribe({
      next: badges => {
        this.badges = badges;
        this.loading = false;
      },
      error: err => {
        this.error = err || this.i18n.t('account.loadError');
        this.loading = false;
      }
    });
  }

  get unlockedCount(): number {
    return this.badges.filter(b => b.unlocked).length;
  }

  get visibleBadges(): Badge[] {
    switch (this.filter) {
      case 'unlocked':
        return this.badges.filter(b => b.unlocked);
      case 'inProgress':
        return this.badges.filter(b => !b.unlocked && !b.locked);
      default:
        // Obtenus d'abord, puis en cours, puis verrouillés
        return [...this.badges].sort((a, b) => this.rank(a) - this.rank(b));
    }
  }

  private rank(badge: Badge): number {
    return badge.unlocked ? 0 : badge.locked ? 2 : 1;
  }

  progress(badge: Badge): number {
    return Math.min(100, (badge.value / badge.threshold) * 100);
  }
}
